import { useRef, useState } from "react";
import { Check, Loader2, Upload, X } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export const PhotoUpload = ({ side, value, onChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(side.key, { path: data.path, url: data.url });
    } catch (err) {
      toast.error("Şəkil yüklənmədi. Yenidən cəhd edin.");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const clear = (e) => {
    e.stopPropagation();
    onChange(side.key, null);
  };

  return (
    <div
      onClick={() => !uploading && inputRef.current?.click()}
      data-testid={`photo-upload-${side.key}`}
      className={`relative cursor-pointer rounded-2xl border aspect-square flex flex-col items-center justify-center overflow-hidden transition-colors ${
        value ? "border-white/40 bg-white/[0.04]" : "border-dashed border-white/12 hover:border-white/40 bg-white/[0.02]"
      }`}
    >
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
      {value ? (
        <>
          <img src={fileUrl(value.url)} alt={side.label} className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent" />
          <button
            onClick={clear}
            data-testid={`photo-clear-${side.key}`}
            className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/60 flex items-center justify-center hover:bg-red-500/80 transition-colors z-10"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="absolute bottom-0 inset-x-0 p-2.5 flex items-center gap-1.5 text-xs font-medium">
            <Check className="w-3.5 h-3.5 text-white" /> {side.label}
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center gap-2 text-center px-2 w-full">
          {uploading ? (
            <Loader2 className="w-6 h-6 text-white animate-spin" />
          ) : (
            <>
              <span className="text-xs text-neutral-400 leading-tight mb-1">{side.label}</span>
              <button type="button" onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}
                data-testid={`photo-upload-btn-${side.key}`}
                className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white/8 text-[11px] text-neutral-200 hover:bg-white/15 transition-colors">
                <Upload className="w-3.5 h-3.5" /> Yüklə
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};
